// TODO: Hacerlo dinámico
export const period = {
    startDate: "2025-12-08",
    endDate: "2026-01-30",
    year: "2025"
}